import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { apiEndpoint } from 'configs'

export const getComodities = createAsyncThunk(
  'project-menu/comodity',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/items?sortby=nameItem&sortdir=asc`,
        config,
      )

      if (data?.totalItems > data?.items?.length) {
        const res = await axios.get(
          `${apiEndpoint}/api/v1/bussines/items?sortby=nameItem&sortdir=asc&page=0&size=${data?.totalItems}`,
          config,
        )
        const newData = res?.data?.items?.map((e) => {
          return {
            value: e.id,
            label: e.nameItem,
            id: e.id,
            img: e.linkFoto,
            image: e.linkFoto,
            sku: e.SKU,
            unit: e.unit,
          }
        })
        return newData
      }

      const newData = data?.items?.map((e) => {
        return {
          value: e.id,
          label: e.nameItem,
          id: e.id,
          img: e.linkFoto,
          image: e.linkFoto,
          sku: e.SKU,
          unit: e.unit,
        }
      })
      return newData
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)
